// extracted by mini-css-extract-plugin
module.exports = {"version":"version_version__U3F_d"};